const values = {
  email: process.env.REACT_APP_CONTACT_EMAIL,
  phone: process.env.REACT_APP_CONTACT_PHONE,
  phoneDisplay: process.env.REACT_APP_CONTACT_PHONE_DISPLAY,
  whatsappUrl: process.env.REACT_APP_WHATSAPP_URL,
};

for (const [key, value] of Object.entries(values)) {
  if (!value) throw new Error(`Missing public contact configuration: ${key}`);
}

export const CONTACT = Object.freeze({
  ...values,
  emailHref: `mailto:${values.email}`,
  phoneHref: `tel:${values.phone}`,
});